import React, { useContext, useEffect, useState } from 'react';
import { Formerror } from '../../components/formerror';
import InfoLogo from '../../components/Info';
import { useGlobalSpinnerActionsContext } from '../../components/loader/useloader';
import validator from 'validator';
import AddGSTModal from './AddGSTModal';
import configData from '../../utils/config/config.json';
import { Context } from '../../services/apiContext';
import {
  getClientIp,
  inputAlphaNumeric,
} from '../../helperFunctions/helperFunctions';

const BasicDetails = ({
  handleFormData,
  basicDetails,
  createAllReferralLink,
  disableAll,
  setstep,
  setStep2Valid,
}) => {
  console.log(basicDetails);
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    mobile: '',
    pan: '',
    gst_flag: 'N',
    gst: '',
    referral_id: '',
  });
  const [basicInfoErrors, setBasicInfoErrors] = useState({});
  const [showGSTModal, setShowGSTModal] = useState({
    value: false,
    parameters: {},
    newOpen: true,
  });
  const contextapi = useContext(Context);

  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  useEffect(() => {
    setProfile(basicDetails);
  }, [basicDetails]);

  const handleOnProfileChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });
    handleFormData(name, value);
    if (name !== 'pan') {
      setBasicInfoErrors({ ...basicInfoErrors, [name]: '' });
    }
  };

  const validatePan = (e) => {
    let txt = e.target.value;
    console.log(txt);
    txt = txt.toUpperCase();
    var regex = /[A-Z]{3}[P]{1}[A-Z]{1}[\d]{4}[A-Z]{1}/;

    if (txt.length === 10) {
      if (!regex.test(txt)) {
        setBasicInfoErrors({
          ...basicInfoErrors,
          pan: 'Invalid PAN ',
          PanVerifed: false,
        });
        e.preventDefault();
      } else {
        setBasicInfoErrors({
          ...basicInfoErrors,
          pan: '',
          PanVerifed: true,
        });
      }
    } else {
      setBasicInfoErrors({
        ...basicInfoErrors,
        pan: 'Invalid PAN ',
        PanVerifed: false,
      });
    }
  };

  const checkErrors = async (data) => {
    const errorsForm = {};
    if (data.name.trim() === '') {
      errorsForm.name = 'Name is required';
    }
    if (data.email.trim() === '') {
      errorsForm.email = 'Email is required';
    }
    if (data.email.trim() !== '' && !validator.isEmail(data.email.trim())) {
      errorsForm.email = 'Email is Invalid';
    }
    if (
      data.name.trim() !== '' &&
      !validator.matches(data.name, '[a-zA-Z][a-zA-Z ]+[a-zA-Z]$')
    ) {
      errorsForm.name = 'Name is Invalid';
    }
    if (data.name.trim() !== '' && data.name.length > 120) {
      errorsForm.name = 'Name should be less tha 120 charcters';
    }
    if (data.email.trim() !== '' && data.email.length > 120) {
      errorsForm.name = 'Email should be less tha 120 charcters';
    }
    if (data.pan.trim() === '') {
      errorsForm.pan = 'PAN is required';
    }

    if (
      !validator.matches(
        profile.pan.trim().toUpperCase(),
        /[a-zA-Z]{3}[P]{1}[a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}$/
      )
    ) {
      errorsForm.pan = 'Invalid PAN';
    }

    return errorsForm;
  };

  const validateBasicInfo = async () => {
    const error = await checkErrors(profile);
    console.log(error);

    if (Object.keys(error).length > 0) {
      await setBasicInfoErrors(error);
    } else {
      if (disableAll) {
        setStep2Valid(true);
        setstep(2);
        // createAllReferralLink();
      } else {
        setShowGSTModal({ ...showGSTModal, value: true, newOpen: true });
      }
    }
  };

  const getReferralFlow = async (data = profile) => {
    setGlobalSpinner(true);
    let referral = '';
    var registrationInfo = await referralRegistration(data);
    if (registrationInfo.status_code === '00') {
      setProfile({ ...profile, referral_id: registrationInfo.referral_id });
      handleFormData('referral_id', registrationInfo.referral_id);
      referral = registrationInfo.referral_id;
    }
    if (referral !== '') {
      setStep2Valid(true);
      createAllReferralLink(referral);
    } else {
      setGlobalSpinner(false);
    }
  };

  const referralRegistration = async (data = profile) => {
    var url = '/referral/register';
    var userData = contextapi.getSession('userData');
    let newData = {};
    newData.user_key = userData.user_key;
    newData.name = data.name;
    newData.pan = data.pan;
    newData.email = data.email;
    newData.mobile = data.mobile;
    newData.gst_flag = data.gst_flag;
    if (data.gst_flag === 'Y') newData.gst = data.gst;
    newData.user_ip = await getClientIp();

    var postobjt = newData;
    let response;
    await contextapi
      .postApiAuthCalling(url, postobjt, true)
      .then((res) => {
        response = res;
      })
      .catch((error) => {
        response = error;
      });
    return response;
  };

  const clickListen = (action, gst_flag, gst) => {
    console.log(action, gst_flag, gst);
    setShowGSTModal({ ...showGSTModal, value: false, newOpen: true });
    if (action === 'addGST' && gst_flag === 'Y') {
      setProfile({
        ...profile,
        gst: gst,
        gst_flag: gst_flag,
      });
      handleFormData('gst', gst);
      handleFormData('gst_flag', gst_flag);
      getReferralFlow({
        ...profile,
        gst: gst,
        gst_flag: gst_flag,
      });
    } else {
      setProfile({
        ...profile,
        gst: '',
        gst_flag: 'N',
      });
      handleFormData('gst', '');
      handleFormData('gst_flag', 'N');
      getReferralFlow({
        ...profile,
        gst: '',
        gst_flag: 'N',
      });
    }
  };

  return (
    <div className='row'>
      <div className='col-12 paddingZero row textCenter'>
        <div className='col-lg-6 col-md-6 col-ms-12 '>
          <div className='form-floating '>
            <input
              type='text'
              className='form-control'
              id='txtName'
              placeholder='Name as per PAN*'
              name='name'
              onChange={handleOnProfileChange}
              required
              disabled={disableAll}
              autoComplete='off'
              value={profile.name}
              maxLength={120}
            />
            <label htmlFor='txtName'>
              Name as per PAN
              <span className='txt-red'>*</span>
            </label>
            <Formerror error={basicInfoErrors.name} />
          </div>
        </div>
        <div className='col-lg-6 col-md-6 col-ms-12 '>
          <div className='form-floating'>
            <input
              type='text'
              className={`form-control  PANtext ${
                basicInfoErrors.PanVerifed === true ? 'PanVerified' : ''
              }`}
              id='Pan'
              placeholder='PAN*'
              name='pan'
              required
              value={profile.pan}
              autoComplete='off'
              disabled={disableAll}
              // onChange={handleOnProfileChange}
              onChange={(e) =>
                inputAlphaNumeric(e, (value) => {
                  e.target.value = value;
                  handleOnProfileChange(e);
                })
              }
              onInput={validatePan}
              maxLength={10}
            />
            <label htmlFor='Pan'>
              PAN<span className='txt-red'>*</span>
            </label>
            <Formerror error={basicInfoErrors.pan} />
          </div>
          <div className='col-lg-2 col-md-2 col-ms-2 relativ'>
            {basicInfoErrors.PanVerifed === true && (
              <span className='pan-msg'>PAN details are valid </span>
            )}
          </div>
        </div>

        <div className='col-lg-6 col-md-6 col-ms-12 '>
          <div className='form-floating emailonhover'>
            <input
              type='text'
              className='form-control '
              // className={(errors.email === '' && profile.email.length>1) ? ("form-control successborder"): ( (errors.email === '')? "form-control " : 'form-control errorborder')}
              id='txtEmail'
              placeholder='Email'
              name='email'
              value={profile.email}
              required
              autoComplete='off'
              disabled={disableAll}
              onChange={(e) => {
                handleOnProfileChange(e);
              }}
              maxLength={120}
            />
            <label htmlFor='txtEmail'>
              Email<span className='txt-red'>*</span>
            </label>
            <Formerror error={basicInfoErrors.email} />
            <div className='inforinemail'>
              <InfoLogo />
              <div className='innerInfo'>
                <div className='inner_innerInfo'>
                  <p>Enter an email id to receive future communication</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-6 col-md-6 col-ms-12 '>
          <div className='form-floating '>
            <input
              type='tel'
              className='form-control '
              id='txtMobile'
              value={profile.mobile}
              placeholder='Mobile'
              readOnly
              autoComplete='off'
              disabled
              name='mobile'
              onChange={handleOnProfileChange}
            />
            <label htmlFor='txtMobile'>
              Mobile <span className='txt-red'>*</span>
            </label>
            <Formerror error={basicInfoErrors.mobile} />
          </div>
        </div>

        <div className='col-lg-12 col-sm-12 textCenter'>
          <button
            type='button'
            name='button'
            className='makewhitcolor btnInuse btn-default makewhitcolor'
            onClick={() => validateBasicInfo()}
          >
            Save and Continue
          </button>
        </div>
        {showGSTModal.value && (
          <AddGSTModal
            openstatus={showGSTModal.value}
            defaultValue={{
              gst_flag: profile.gst_flag,
              gst: profile.gst,
              newOpen: true,
            }}
            title={'Add GST'}
            clickListen={clickListen}
          />
        )}
      </div>
    </div>
  );
};

export default BasicDetails;
